import { AxiosRequestConfig } from 'axios';
import axios from './axios';

// ─── Reactions ────────────────────────────────────────────────────────────────

const addReaction = (cardId: string, recipientEmail: string, emojiType: string): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        try {
            const config: AxiosRequestConfig = {
                method: 'post',
                url: `/api/engagement/${cardId}/reactions`,
                data: { recipientEmail, emojiType },
            };
            const resp = await axios(config);
            resolve(resp.data.data);
        } catch (error) {
            reject(error);
        }
    });
};

const removeReaction = (cardId: string, recipientEmail: string, emojiType: string): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        try {
            const config: AxiosRequestConfig = {
                method: 'delete',
                url: `/api/engagement/${cardId}/reactions/${encodeURIComponent(emojiType)}`,
                data: { recipientEmail },
            };
            const resp = await axios(config);
            resolve(resp.data);
        } catch (error) {
            reject(error);
        }
    });
};

const getReactions = (cardId: string): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        try {
            const config: AxiosRequestConfig = {
                method: 'get',
                url: `/api/engagement/${cardId}/reactions`,
            };
            const resp = await axios(config);
            resolve(resp.data.data);
        } catch (error) {
            reject(error);
        }
    });
};

// ─── Comments ─────────────────────────────────────────────────────────────────

const addComment = (
    cardId: string,
    payload: { authorEmail: string; authorName: string; commentText: string; isAnonymous?: boolean; parentCommentId?: string },
): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        try {
            const config: AxiosRequestConfig = {
                method: 'post',
                url: `/api/engagement/${cardId}/comments`,
                data: payload,
            };
            const resp = await axios(config);
            resolve(resp.data.data);
        } catch (error) {
            reject(error);
        }
    });
};

const getComments = (cardId: string): Promise<any[]> => {
    return new Promise(async (resolve, reject) => {
        try {
            const config: AxiosRequestConfig = {
                method: 'get',
                url: `/api/engagement/${cardId}/comments`,
            };
            const resp = await axios(config);
            resolve(resp.data.data);
        } catch (error) {
            reject(error);
        }
    });
};

const deleteComment = (commentId: string, requestingEmail: string): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        try {
            const config: AxiosRequestConfig = {
                method: 'delete',
                url: `/api/engagement/comments/${commentId}`,
                data: { requestingEmail },
            };
            const resp = await axios(config);
            resolve(resp.data);
        } catch (error) {
            reject(error);
        }
    });
};

// ─── Download Logging ─────────────────────────────────────────────────────────

const logDownload = (cardId: string, recipientEmail: string, format: 'png' | 'pdf' | 'gif'): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        try {
            const config: AxiosRequestConfig = {
                method: 'post',
                url: `/engagement/${cardId}/download-log`,
                data: { recipientEmail, format },
            };
            const resp = await axios(config);
            resolve(resp.data.data);
        } catch (error) {
            // Fire-and-forget: swallow errors so download still completes
            console.warn('Failed to log download event:', error);
            resolve(null);
        }
    });
};

export const engagementService = {
    addReaction,
    removeReaction,
    getReactions,
    addComment,
    getComments,
    deleteComment,
    logDownload,
};
